import { ComponentProps } from 'react'
import { webchatClasses } from '../../../styles/classes'
import { RowBlock, type CommonBlockProps } from '../../../types'
import { Block } from '../../Block'

type Props = RowBlock & ComponentProps<'div'> & CommonBlockProps

export const Row = ({
  ref,
  blocks,
  horizontalAlignment,
  verticalAlignment,
  direction,
  sender,
  timestamp,
  messageId,
  isReadOnly,
  sendMessage,
  ...props
}: Props) => {
  const {
    message: {
      blocks: { row },
    },
  } = webchatClasses

  return (
    <div data-horizontal={horizontalAlignment} data-vertical={verticalAlignment} {...props} {...row} ref={ref}>
      {blocks.map((block, index) => (
        <Block key={index} block={{ ...block, direction, timestamp, sender, messageId, isReadOnly, sendMessage }} />
      ))}
    </div>
  )
}

Row.displayName = 'Row'
